import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import * as _ from 'lodash';
import { ItemPickerModel } from '../../item-picker/models/itemPickerModel';
import { ODataFilter } from '../../odata-filter/models/odata-filter';
import { SearchValueType } from '../../odata-filter/models/search-value-type';
import { QuickFilterItem } from '../quick-odata-filter-item/quick-odata-filter-item.component';
import { ManageFilterModel } from 'src/app/shared/models/manageFilterModel';

@Component({
  selector: 'manage-qiuck-odata-filters',
  templateUrl: './manage-qiuck-odata-filters.component.html',
  styleUrls: ['./manage-qiuck-odata-filters.component.scss'],
})
export class ManageQiuckOdataFiltersComponent implements OnInit {
  @Input() filters: ODataFilter[] = [];
  @Input() quickFilters: QuickFilterItem[] = [];
  @Output() cancel = new EventEmitter();
  @Output() apply = new EventEmitter<string[]>();
  itemPickerList: ItemPickerModel[] = [];
  manageFilterItems: ManageFilterModel[] = [];

  constructor() {}

  ngOnInit(): void {
    this.manageFilterItems = _.sortBy(
      this.quickFilters.map((x) => {
        let filter: ManageFilterModel = {
          name: x.group ? `${x.filter.displayName} (${x.group})` : x.filter.displayName,
          rank: x.rank,
        };
        return filter;
      }),
      (m) => m.rank
    );
    this.createItemPickerList();
  }

  onDeleteFilter(filter: ManageFilterModel) {
    this.manageFilterItems.splice(this.manageFilterItems.indexOf(filter), 1);
    for (let index = 0; index < this.manageFilterItems.length; index++) {
      this.manageFilterItems[index].rank = index;
    }
    this.createItemPickerList();
  }
  onAddFilter(itemPicker: ItemPickerModel) {
    let selectedFilter = this.filters.find((x) => x.displayName === itemPicker.id);
    if (selectedFilter) {
      this.manageFilterItems.push({ name: itemPicker.name, rank: this.manageFilterItems.length });
      this.createItemPickerList();
    }
  }
  onApply() {
    this.apply.emit(this.manageFilterItems.map((x) => x.name));
  }
  onValueListItemDropped(event: CdkDragDrop<string[]>) {
    if (event.currentIndex === event.previousIndex) return;

    this.moveColumn(event.previousIndex, event.currentIndex);
  }
  private moveColumn(oldIndex: number, newIndex: number) {
    let movedValue = this.manageFilterItems.splice(oldIndex, 1);
    this.manageFilterItems.splice(newIndex, 0, ...movedValue);
    for (let index = 0; index < this.manageFilterItems.length; index++) {
      this.manageFilterItems[index].rank = index;
    }
  }
  private createItemPickerList() {
    this.itemPickerList = this.filters
      .filter(
        (filter) =>
          !this.manageFilterItems.find(
            (m) =>
              m.name == filter.displayName ||
              m.name == `${filter.displayName} (${filter.filterGroup})`
          )
      )
      .map((x) => {
        if (this.filters.filter((f) => f.displayName == x.displayName).length > 1) {
          return new ItemPickerModel(
            x.displayName,
            this.getIcon(x.valueType),
            `${x.displayName} (${x.filterGroup})`
          );
        } else {
          return new ItemPickerModel(x.displayName, this.getIcon(x.valueType), x.displayName);
        }
      });
  }

  private getIcon(type: SearchValueType): string {
    switch (type) {
      case SearchValueType.Date:
        return 'today';
      case SearchValueType.DateRange:
        return 'date_range';
      case SearchValueType.List || SearchValueType.Boolean:
        return 'arrow_drop_down_circle';
      case SearchValueType.MultiValue:
        return 'checklist';
      case SearchValueType.String:
        return 'subject';
      case SearchValueType.Number:
        return 'looks_one';
      default:
        return '';
    }
  }
}
